<template>
  <v-form lazy-validation ref="copyToCreateForm" v-model="valid">
    <v-row dense style="align-items: center;">
      <v-col>
        <v-text-field
          label="Username"
          :rules="rules.username"
          v-model="invitee.username"
          :disabled="loading"
          maxlength="200"
        >
        </v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="Email"
          :rules="rules.email"
          v-model="invitee.email"
          :disabled="loading"
          maxlength="200"
        >
        </v-text-field>
      </v-col>
      <v-col>
        <v-btn
          @click="inviteCopyTo"
          :disabled="!valid"
          style="margin-left: 1rem;"
          >Invite</v-btn
        >
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";
import { getForm } from "@/utils";
import rules from "@/utils/rules";

export default {
  name: "CopyToInvite",
  props: ["inviteCompleteCb"],
  data() {
    return {
      rules: {
        email: [rules.email, rules.required],
        username: [
          rules.required,
          v => /^[a-zA-Z0-9]+$/.test(v) || "Username must be alphanumeric"
        ]
      },
      invitee: {
        email: "",
        username: ""
      },
      loading: false,
      valid: false
    };
  },
  methods: {
    ...mapActions(["notify"]),
    ...mapActions("copyTo", ["invite"]),
    clearForm() {
      this.invitee.email = "";
      this.invitee.username = "";
    },
    // Validate email, option to return string or bool
    email(v, returnBool = false) {
      return (
        !v ||
        /.+@.+\..+/.test(v) ||
        (returnBool ? false : "Email must be valid")
      );
    },
    inviteCopyTo() {
      if (this.invitee.email?.trim() === "") return false;
      // Requires full validation for parent form flow if submit hasn't occurred, but only email validation for invite
      if (!this.email(this.invitee.email?.trim(), true)) return false;
      this.loading = true;
      this.invite({
        email: this.invitee.email?.trim(),
        username: this.invitee.username?.trim()
      }).then(res => {
        if (typeof this.inviteCompleteCb === "function") {
          this.inviteCompleteCb(res);
        }
        const message = res
          ? `${this.invitee.email?.trim()} Invited!`
          : "There was an error inviting this user";
        this.notify({ message, color: res ? "success" : "error" });
        if (res) {
          this.clearForm();
        }
        getForm(this).resetValidation();
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped></style>
